
/* eslint-disable */

const awsmobile = {
	aws_project_region: 'us-east-1',
	aws_cognito_identity_pool_id: 'us-east-1:28d64230-f9a0-4606-8c6d-0ede5d19b7f1',
	aws_cognito_region: 'us-east-1',
	aws_user_pools_id: 'us-east-1_ueeCfQ8Dv',
	aws_user_pools_web_client_id: '4dlge5jpta4b00bs8krs0drp60',
	oauth: {},
	debug: '0',
	aws_cloud_logic_custom: [
		{
			name: 'management',
			endpoint: 'https://portal.mdmesolutions.com/api',
			region: 'us-east-1'
		},
		{
			name: 'admin',
			endpoint: 'https://portal.mdmesolutions.com/api',
			region: 'us-east-1'
		},
		{
			name: 'external',
			endpoint: 'https://portal.mdmesolutions.com/api',
			region: 'us-east-1'
		},
		{
			name: 'files',
			endpoint: 'https://portal.mdmesolutions.com/api',
			region: 'us-east-1'
		},
		{
			name: 'consumers',
			endpoint: 'https://portal.mdmesolutions.com/api',
			region: 'us-east-1'
		}
	],
	aws_user_files_s3_bucket: 'mdme-public123414-production',
	aws_user_files_s3_bucket_region: 'us-east-1'
};

export default awsmobile;
